import { supabase, q } from '../lib/supabase.js';
import * as Demo from '../demo/demo.js';

/**
 * Comentários por item de conferência.
 *
 * Diferente da observação do item:
 *   · observação = quem executa anota o que falta ("extrato de julho não veio")
 *   · comentário = quem revisa explica o que aconteceu e o que melhorar
 *     ("esse lançamento entrou no acumulador errado — confira o resumo antes
 *      de integrar")
 */

export const TIPOS = {
  correcao: { rotulo: 'Correção', tag: 'red' },
  orientacao: { rotulo: 'Orientação', tag: 'amber' },
  duvida: { rotulo: 'Dúvida', tag: 'purple' },
};

const CAMPOS = `
  id, item_id, tipo, texto, resolvido, criado_em, resolvido_em,
  autor:colaboradores!comentarios_autor_id_fkey ( id, nome ),
  resolvedor:colaboradores!comentarios_resolvido_por_fkey ( id, nome )
`;

export async function listar(itemIds) {
  if (!itemIds?.length) return [];

  if (Demo.emDemonstracao) {   // guarda do modo demonstração
    return Demo.comentarios
      .filter((c) => itemIds.includes(c.item_id))
      .sort((a, b) => a.criado_em.localeCompare(b.criado_em));
  }

  return q(
    supabase.from('comentarios').select(CAMPOS).in('item_id', itemIds).order('criado_em')
  );
}

export async function criar({ itemId, tipo, texto }, colaboradorId) {
  if (Demo.emDemonstracao) {   // guarda do modo demonstração
    const novo = {
      id: 'cm-demo-' + Date.now(), item_id: itemId, tipo, texto,
      resolvido: false, resolvido_em: null, resolvedor: null,
      criado_em: new Date().toISOString(),
      autor: Demo.colaboradores.find((c) => c.id === colaboradorId),
    };
    Demo.comentarios.push(novo);
    return novo;
  }

  const [linha] = await q(
    supabase
      .from('comentarios')
      .insert({ item_id: itemId, tipo, texto, autor_id: colaboradorId })
      .select(CAMPOS)
  );
  return linha;
}

/** Quem recebeu a orientação também resolve — não só quem escreveu. */
export async function marcarResolvido(id, resolvido, colaboradorId) {
  if (Demo.emDemonstracao) {   // guarda do modo demonstração
    const c = Demo.comentarios.find((x) => x.id === id);
    if (!c) return null;
    c.resolvido = resolvido;
    c.resolvido_em = resolvido ? new Date().toISOString() : null;
    c.resolvedor = resolvido ? Demo.colaboradores.find((x) => x.id === colaboradorId) : null;
    return c;
  }

  const [linha] = await q(
    supabase
      .from('comentarios')
      .update({
        resolvido,
        resolvido_por: resolvido ? colaboradorId : null,
        resolvido_em: resolvido ? new Date().toISOString() : null,
      })
      .eq('id', id)
      .select(CAMPOS)
  );
  return linha;
}

export async function remover(id) {
  if (Demo.emDemonstracao) {   // guarda do modo demonstração
    const i = Demo.comentarios.findIndex((x) => x.id === id);
    if (i >= 0) Demo.comentarios.splice(i, 1);
    return;
  }
  await q(supabase.from('comentarios').delete().eq('id', id));
}

/** Comentários em aberto — alimenta o aviso no painel. */
export async function emAberto() {
  if (Demo.emDemonstracao) {   // guarda do modo demonstração
    return Demo.comentarios.filter((c) => !c.resolvido).map((c) => {
      const item = Demo.itens.find((i) => i.id === c.item_id);
      const f = item && Demo.fechamentos.find((x) => x.id === item.fechamento_id);
      const e = f && Demo.empresas.find((x) => x.id === f.empresa_id);
      return {
        id: c.id, item_id: c.item_id, tipo: c.tipo, texto: c.texto, criado_em: c.criado_em,
        item_nome: item?.nome, competencia: f?.competencia,
        empresa_id: e?.id, empresa_nome: e?.nome, autor_nome: c.autor?.nome,
      };
    });
  }

  return q(supabase.from('v_comentarios_abertos').select('*').order('criado_em', { ascending: false }));
}
